import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useGetUserQuery } from "../store/api";

const normalizeLabel = (value) => {
  if (value === undefined || value === null) return "";
  const text = String(value).trim();
  return text;
};

const getInitials = (name) => {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (!parts.length) return "OP";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
};

export const useCurrentOperator = () => {
  const user = useSelector((state) => state.auth.user);
  const userId = user?.userId || null;
  const { data: currentUser, isLoading } = useGetUserQuery(userId, {
    skip: !userId,
  });

  const operatorName = useMemo(() => {
    const apiLabel =
      normalizeLabel(currentUser?.displayName) ||
      normalizeLabel(currentUser?.name) ||
      normalizeLabel(currentUser?.fullName);
    if (apiLabel) return apiLabel;

    const authLabel =
      normalizeLabel(user?.displayName) ||
      normalizeLabel(user?.name) ||
      normalizeLabel(user?.fullName);
    if (authLabel) return authLabel;

    return isLoading ? "Loading user..." : "Operator";
  }, [currentUser, isLoading, user]);

  return {
    user,
    userId,
    currentUser,
    isLoading,
    operatorName,
    operatorInitials: getInitials(operatorName),
  };
};

export default useCurrentOperator;
